import format from 'date-fns/esm/format'
import { PreviewData } from '.'

export function buildTimestampOverlay(
  timestamp: PreviewData['timestamp'],
  dark: boolean
) {
  return {
    type: 'text',
    content: safeFormat(timestamp.format, new Date()),
    font: timestamp.font.family,
    font_size: timestamp.font_size,
    fill: dark ? '#000000' : '#FFFFFF',
  }
}

const splitRegex = /\[\$([0-9]+)\]/
export function buildNumberingOverlay(
  numbering: PreviewData['numbering'],
  dark: boolean
) {
  const [front = '', padding = '0', back = ''] =
    numbering.format.split(splitRegex)
  const number = '1'.padStart(Number(padding) || 0, '0')

  return {
    type: 'text',
    content: `${front}${number}${back}`,
    font: numbering.text_font.family,
    font_size: numbering.text_font_size,
    fill: dark ? '#000000' : '#FFFFFF',
    styles: {
      0: Object.fromEntries(
        new Array(number.length).fill(null).map((_, i) => [
          front.length + i,
          {
            fontSize: numbering.number_font_size,
            fontFamily: numbering.number_font.family,
          },
        ])
      ),
    },
  }
}

function safeFormat(fmt: string, date: Date) {
  try {
    return format(date, fmt)
  } catch {
    return date.toString()
  }
}
